<template>
    <div id="printTable">
        <report-header>
          <h2>
            {{  reportHeaderText }}
          </h2>
        </report-header>
        <v-row>
            <v-col cols="12">
                <v-data-table
                    :headers="tableHeaders"
                    :items="tableData"
                    sort-by="Date"
                    sort-desc
                    class="elevation-1"
                    :items-per-page="-1"
                >
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import ReportHeader from '@/components/Report/ReportHeader.vue';

export default {
  components: {
    ReportHeader
  },

    props: {
        reportHeaderText: {
            type: String,
            default: ""
        },
        tableHeaders: {
            type: Array,
            default: function () {
                return [];
            }
        },
        tableData: {
            type: Array,
            default: function () {
                return [];
            }
        },
    }
}
</script>